import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { AssetColumns } from "~/modules/assets/types";
import { Emdash } from "~/components/Punctuation";
import { DataGridDollarPercentChangeComboCell } from "~/components/DataGrid/DataGridDollarPercentChangeComboCell";
import { getMeasureValue } from "~/utils/getMeasureValue";
import { AssetTableRowData } from "../types";
import { CatalogMetricSlugs } from "~/modules/catalog/types";

// // // //

// NOTE - label + tooltip are the same as Market Value column
export const BRIDGED_TOKEN_MARKET_CAP_DOLLAR_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.bridgedTokenMarketCapDollar,
    label: "Market Cap",
    tooltip: CatalogMetricSlugs.bridged_token_market_cap_dollar,
    type: ColumnTypes.dollar,
    sortsOn: AssetColumns.bridgedTokenMarketCapDollar,
    width: 180,
    render: (item) => {
        const measure = getMeasureValue(
            item,
            "bridged_token_market_cap_dollar",
        );

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridDollarPercentChangeComboCell
                value={measure.val}
                pct_change_interval="30d"
                pct_change_value={measure.chg_30d_pct}
            />
        );
    },
};
